import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import asyncThunks from '../async-thunks';
import { CustomerGroupSelectorState } from '../types';

const getContext = (
  builder: ActionReducerMapBuilder<CustomerGroupSelectorState>,
) => {
  builder.addCase(
    asyncThunks.getContext.pending,
    (state: CustomerGroupSelectorState) => {
      state.isLoading = true;
      state.isError = false;
    },
  );
  builder.addCase(
    asyncThunks.getContext.fulfilled,
    (state: CustomerGroupSelectorState, action) => {
      state.isError = false;
      state.context = action.payload;

      const customerContextChangedEvent = new CustomEvent(
        'customer-context-changed',
        {
          detail: action.payload,
        },
      );
      window.dispatchEvent(customerContextChangedEvent);
    },
  );
  builder.addCase(
    asyncThunks.getContext.rejected,
    (state: CustomerGroupSelectorState) => {
      state.isLoading = false;
      state.isError = true;
    },
  );
};

export default getContext;
